import styled from 'styled-components';

interface QuestionAnswerWrapperProps {
  $$ShowElement: boolean;
}

export const MainWrapper = styled.div<{$$isPWA?: boolean}>(
  props => `
    ${!props.$$isPWA ? 'margin: 2.5rem auto 0; max-width: 120rem; padding: 2rem 2.5rem;' : 'flex-direction: column; padding: 1.6rem;'}
    width: 100%;
    border-bottom: 0.1rem solid #E1E7EE;
    display: flex;
    background-color: ${props.theme.colors.goWhite.base};
    border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  `,
);

export const FaqsHeaderWrapper = styled.div<{$$isPWA?: boolean}>(
  props => `
  ${props.$$isPWA ? 'margin-bottom: 1.8rem;' : 'width: 35%;'}
`,
);

export const QuestionAnswerContainer = styled.div<{$$isPWA?: boolean}>(
  props => `
  ${!props.$$isPWA ? 'padding: 0rem 2.5rem; width: 65%;' : ''}
    `,
);

export const SearchBarWrapper = styled.div(
  props => `
        width: 100%;
        margin-bottom: ${props.theme.spacing.xlarge};
    `,
);

export const showAllQuestionsButton = styled.p(
  props => `
    line-height: normal;
    font-size: ${props.theme.font.custom(16)};
    font-weight: 600;
    color: ${props.theme.colors.goBrandBlue.base};
    cursor: pointer;
    `,
);

export const QuestionAnswerWrapper = styled.div<QuestionAnswerWrapperProps>(
  props => `
    ${props.$$ShowElement ? 'display: flex; flex-direction: column;' : 'display: none;'}
    margin-bottom: ${props.theme.spacing.xlarge};
  `,
);

export const QuestionsWrapper = styled.div(
  props => `
        display: flex;
        align-items: center;
        justify-content: space-between;
    `,
);

export const QuestionText = styled.p(
  props => `
    font-size: ${props.theme.font.custom(14)};
    font-weight: 600;
  `,
);

export const AnswerText = styled.p<{$$ShowAnswer: boolean}>(
  props => `
    ${props.$$ShowAnswer ? 'display: block;' : 'display: none;'}
    font-size: ${props.theme.font.custom(14)};
  `,
);

export const ModalWrapper = styled.div(
  props => `
      width: 80rem;
      padding: 2rem 4rem;
  `,
);

export const ModalPWAHeader = styled.div(
  props => `
    padding: 1.6rem;
    width: 100%;
    height: 100vh;
  `,
);
